import { useEffect } from 'react'
import { apiGet, useQuery } from './hooks'
import type { Envelope, FolderSummary } from './types'

export function useLibraryFolders(allowed: boolean) {
  const query = useQuery<Envelope<FolderSummary[]>>(async () => {
    if (!allowed) return { trace_id: '-', data: [] }
    const rows: FolderSummary[] = [], seen = new Set<string>()
    let cursor: string | undefined
    do {
      const page = await apiGet<Envelope<FolderSummary[]>>('/folders', { limit: 200, cursor })
      rows.push(...page.data)
      cursor = page.next_cursor || undefined
      if (cursor && seen.has(cursor)) throw new Error('目录分页异常，请刷新后重试')
      if (cursor) seen.add(cursor)
    } while (cursor)
    return { trace_id: '-', data: rows }
  }, [allowed])
  useEffect(() => {
    const reload = () => { void query.reload() }
    window.addEventListener('kb:folders-changed', reload)
    return () => window.removeEventListener('kb:folders-changed', reload)
  }, [query.reload])
  return query
}
